export default "__VITE_ASSET__CgMsczlX__"